//@flow
import FunctionStore from '../Base/functionStoreClass';
import { apiUpdateState, applyServerDefaultData } from '../Base/storeUtils';
import Constants from '../../constants';
import Api from '../../APIInterfaces/stock';
import StockCollection from './stockCollection';
import { toImmutable } from '../../Utils/immutable';

import type { HandlerAdd, StoreState } from '../Base/functionStoreClass';
import type { StockObject } from './stockCollection';

export default class StockStore extends FunctionStore {
  getStock():StockCollection {
    return this._resolvePropertyObject('stock', StockCollection, Api.getStock);
  }

  _initialState(state:StoreState) {
    applyServerDefaultData('stockData', state, _handleGetStock);
  }

  _setup(onSuccess:HandlerAdd, onError:HandlerAdd) {
    onSuccess(Constants.GET_STOCK_SUCCESS, apiUpdateState(_handleGetStock));
  }
}

function _handleGetStock(state:StoreState, resp:StockObject) {
  state.set('stock', toImmutable(resp));
}
